import styled from 'styled-components';
import { AllieCard } from '../Card';

export const StyledContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const StyledWidgetCard = styled(AllieCard)`
  width: 100%;
  border-radius: 16px;
  margin: 10px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ion-card-content {
    padding-left: var(--allie-spacing-lg);
    padding-right: var(--allie-spacing-lg);
    padding-inline-start: var(--allie-spacing-lg);
    padding-inline-end: var(--allie-spacing-lg);
  }
`;
